import React from "react"
import Globe from 'react-globe.gl'
// import starField from './starField.png'

const PlainPlaces = () => <Globe />

export default PlainPlaces;
